import {Alert} from 'src/design/atoms/Alert';
import {IconWifiOff} from '@tabler/icons-react';
import React from 'react';
import {matchPath, useLocation} from 'react-router-dom';
import {useOfflineStatus} from 'src/offline/useOfflineStatus';
import {PathUtility} from 'src/shared/constants/PathBuilder';

// Inspector screens with their own inline pill; `.../list/:id` also matches the
// pill-less create route, excluded via the `:id !== 'create'` guard below.
const PILL_ROUTES = [
  PathUtility.InspectionsMy(':id'),
  PathUtility.Inspections(':view'),
  PathUtility.InspectionsView(':id'),
  PathUtility.InspectionsRecord(':id', ':deviceId'),
];

/**
 * Persistent offline strip mounted once in the app shell — suppressed on the
 * inspector screens, which show their own inline pill instead.
 */
export const OfflineStatusBanner: React.FC = () => {
  const {pathname} = useLocation();
  const {isOffline, message} = useOfflineStatus();

  const suppressedByPill = PILL_ROUTES.some(pattern => {
    const match = matchPath(pattern, pathname);
    return match !== null && match.params.id !== 'create';
  });

  if (suppressedByPill) {
    return null;
  }

  if (!isOffline) {
    return null;
  }

  return (
    <Alert
      color="yellow"
      variant="filled"
      icon={<IconWifiOff />}
      p="xs"
      mb="md"
      aria-live="polite">
      {message}
    </Alert>
  );
};
